import Morphism, { Schema } from 'morphism';
import { isPresent, present } from '../utils/typescript';

export function parseEntity<T>(data: any, schema: Schema, type: new () => T): T | null {
  return data ? Morphism(schema, data, type) : null;
}

export function parseNumericId<T>(value: any): T | null {
  if (!isPresent(value)) return null;
  const n = typeof value === 'string' ? parseInt(value, 10) : +value;
  if (Number.isNaN(n)) return null;
  return n as any as T;
}

export type ParseElement<T> = (data: any) => T | null;

export function parseEntities<T>(data: any, parseElement: ParseElement<T>): Array<T>;
export function parseEntities<T>(data: any, schema: Schema, type: new () => T): Array<T>;

export function parseEntities<T>(data: any, parseElementOrSchema: any, type?: any): Array<T> {
  if (!data) return [];
  if (!Array.isArray(data)) {
    // eslint-disable-next-line no-console
    console.error('Not an array:', data);
    return [];
  }
  const parseElement: ParseElement<T> = type ? (d: any) => Morphism(parseElementOrSchema as Schema, d, type) : parseElementOrSchema;
  return data.map(parseElement).map(e => present(e));
}
